import { shotGrid } from '@/mocks/exposure';
import { SectionHead, Tag } from './ui';

export default function ScreenshotSection() {
  const [lead, ...rest] = shotGrid;
  return (
    <section id="screenshot" className="mx-auto w-full max-w-[1280px] px-4 py-9 md:px-6 md:py-12">
      <SectionHead
        no="01"
        title="证据截图 · 实锤档案"
        sub="逐张核验来源、标注修改痕迹的截图专区，直接对照查看"
        more="进入截图专区"
        href="#"
      />

      {/* 头条大图卡片 + 右列列表 */}
      <div className="grid gap-4 md:gap-5 lg:grid-cols-3">
        <a href="#" className="group relative block overflow-hidden rounded-xl bg-foreground-900 lg:col-span-2">
          <img
            src={lead.img}
            alt={lead.title}
            className="h-[300px] w-full object-cover object-top opacity-90 transition duration-500 group-hover:scale-[1.03] md:h-[360px]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-transparent to-transparent" />
          <div className="absolute inset-x-0 bottom-0 p-5">
            <div className="mb-2 flex items-center gap-2">
              <Tag tone="accent">{lead.tag}</Tag>
              <span className="text-[11px] text-background-200">{lead.time}</span>
            </div>
            <h3 className="font-serif text-lg font-black leading-snug text-background-50 md:text-2xl">
              {lead.title}
            </h3>
            <p className="mt-2 inline-flex items-center gap-3 text-xs text-background-300">
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-file-image-line" /> 共 {lead.count}
              </span>
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-fire-fill text-accent-400" /> {lead.heat}
              </span>
            </p>
          </div>
        </a>

        {/* 右列短条目（纯文字，配图克制） */}
        <div className="flex flex-col rounded-xl border border-background-200 bg-background-100/70 p-4 md:p-5">
          <div className="flex items-center justify-between border-b border-background-200 pb-3">
            <span className="flex items-center gap-2 text-sm font-bold text-foreground-800">
              <i className="ri-stack-line text-primary-500" /> 近 24h 新增截图
            </span>
            <span className="text-xs font-semibold text-accent-600">+18 组</span>
          </div>
          <ul className="mt-2 flex flex-1 flex-col divide-y divide-background-200">
            {rest.map((s, i) => (
              <li key={i}>
                <a href="#" className="group flex items-center gap-3 py-2.5">
                  <img
                    src={s.img}
                    alt=""
                    aria-hidden
                    className="h-10 w-10 shrink-0 rounded-md object-cover object-top"
                  />
                  <span className="min-w-0 flex-1">
                    <span className="line-clamp-1 block text-sm font-medium text-foreground-800 group-hover:text-primary-700">
                      {s.title}
                    </span>
                    <span className="mt-0.5 flex items-center gap-2 text-[11px] text-foreground-400">
                      <Tag tone="secondary">{s.tag}</Tag>
                      <span className="whitespace-nowrap">{s.count}</span>
                      <span className="whitespace-nowrap">{s.heat}</span>
                    </span>
                  </span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}